import React from 'react'

const Testimonail = () => {
  return (
    <section className="testimonial-section">
  <div className="auto-container">
    <div className="outer-box">
      <div className="row">
        {/* Testimonial Block */}
        <div className="testimonial-block col-lg-4 col-md-6 col-sm-12">
          <div className="inner-box">
            <div className="text-box">
              <p>
                Lorem ipsum dolor sit amet consectur adipisicing elit eiusmod
                tempor incididunt ut labore dolore magna.enim minim veniam.quis
                nostrud exercitation.
              </p>
            </div>
            <div className="info-box">
              <div className="thumb">
                <img src="/assets/images/resource/testi-thumb-1.jpg" alt="" />
              </div>
              <div className="rating">
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
              </div>
              <h5 className="name">Monika Vance</h5>
              <span className="designation">Development Expert</span>
            </div>
          </div>
        </div>
        {/* Testimonial Block */}
        <div className="testimonial-block col-lg-4 col-md-6 col-sm-12">
          <div className="inner-box">
            <div className="text-box">
              <p>
                Lorem ipsum dolor sit amet consectur adipisicing elit eiusmod
                tempor incididunt ut labore dolore magna.enim minim veniam.quis
                nostrud exercitation.
              </p>
            </div>
            <div className="info-box">
              <div className="thumb">
                <img src="/assets/images/resource/testi-thumb-2.jpg" alt="" />
              </div>
              <div className="rating">
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
              </div>
              <h5 className="name">Thomas Jakson</h5>
              <span className="designation">Development Expert</span>
            </div>
          </div>
        </div>
        {/* Testimonial Block */}
        <div className="testimonial-block col-lg-4 col-md-6 col-sm-12">
          <div className="inner-box">
            <div className="text-box">
              <p>
                Lorem ipsum dolor sit amet consectur adipisicing elit eiusmod
                tempor incididunt ut labore dolore magna.enim minim veniam.quis
                nostrud exercitation.
              </p>
            </div>
            <div className="info-box">
              <div className="thumb">
                <img src="/assets/images/resource/testi-thumb-3.jpg" alt="" />
              </div>
              <div className="rating">
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
              </div>
              <h5 className="name">Thomas Jakson</h5>
              <span className="designation">Development Expert</span>
            </div>
          </div>
        </div>
        {/* Testimonial Block */}
        <div className="testimonial-block col-lg-4 col-md-6 col-sm-12">
          <div className="inner-box">
            <div className="text-box">
              <p>
                Lorem ipsum dolor sit amet consectur adipisicing elit eiusmod
                tempor incididunt ut labore dolore magna.enim minim veniam.quis
                nostrud exercitation.
              </p>
            </div>
            <div className="info-box">
              <div className="thumb">
                <img src="/assets/images/resource/testi-thumb-3.jpg" alt="" />
              </div>
              <div className="rating">
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
              </div>
              <h5 className="name">Thomas Jakson</h5>
              <span className="designation">Development Expert</span>
            </div>
          </div>
        </div>
        {/* Testimonial Block */}
        <div className="testimonial-block col-lg-4 col-md-6 col-sm-12">
          <div className="inner-box">
            <div className="text-box">
              <p>
                Lorem ipsum dolor sit amet consectur adipisicing elit eiusmod
                tempor incididunt ut labore dolore magna.enim minim veniam.quis
                nostrud exercitation.
              </p>
            </div>
            <div className="info-box">
              <div className="thumb">
                <img src="/assets/images/resource/testi-thumb-1.jpg" alt="" />
              </div>
              <div className="rating">
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
              </div>
              <h5 className="name">Monika Vance</h5>
              <span className="designation">Development Expert</span>
            </div>
          </div>
        </div>
        {/* Testimonial Block */}
        <div className="testimonial-block col-lg-4 col-md-6 col-sm-12">
          <div className="inner-box">
            <div className="text-box">
              <p>
                Lorem ipsum dolor sit amet consectur adipisicing elit eiusmod
                tempor incididunt ut labore dolore magna.enim minim veniam.quis
                nostrud exercitation.
              </p>
            </div>
            <div className="info-box">
              <div className="thumb">
                <img src="/assets/images/resource/testi-thumb-2.jpg" alt="" />
              </div>
              <div className="rating">
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
              </div>
              <h5 className="name">Thomas Jakson</h5>
              <span className="designation">Development Expert</span>
            </div>
          </div>
        </div>
        {/* Testimonial Block */}
        <div className="testimonial-block col-lg-4 col-md-6 col-sm-12">
          <div className="inner-box">
            <div className="text-box">
              <p>
                Lorem ipsum dolor sit amet consectur adipisicing elit eiusmod
                tempor incididunt ut labore dolore magna.enim minim veniam.quis
                nostrud exercitation.
              </p>
            </div>
            <div className="info-box">
              <div className="thumb">
                <img src="/assets/images/resource/testi-thumb-3.jpg" alt="" />
              </div>
              <div className="rating">
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
              </div>
              <h5 className="name">Thomas Jakson</h5>
              <span className="designation">Development Expert</span>
            </div>
          </div>
        </div>
        {/* Testimonial Block */}
        <div className="testimonial-block col-lg-4 col-md-6 col-sm-12">
          <div className="inner-box">
            <div className="text-box">
              <p>
                Lorem ipsum dolor sit amet consectur adipisicing elit eiusmod
                tempor incididunt ut labore dolore magna.enim minim veniam.quis
                nostrud exercitation.
              </p>
            </div>
            <div className="info-box">
              <div className="thumb">
                <img src="/assets/images/resource/testi-thumb-3.jpg" alt="" />
              </div>
              <div className="rating">
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
              </div>
              <h5 className="name">Thomas Jakson</h5>
              <span className="designation">Development Expert</span>
            </div>
          </div>
        </div>
        {/* Testimonial Block */}
        <div className="testimonial-block col-lg-4 col-md-6 col-sm-12">
          <div className="inner-box">
            <div className="text-box">
              <p>
                Lorem ipsum dolor sit amet consectur adipisicing elit eiusmod
                tempor incididunt ut labore dolore magna.enim minim veniam.quis
                nostrud exercitation.
              </p>
            </div>
            <div className="info-box">
              <div className="thumb">
                <img src="/assets/images/resource/testi-thumb-1.jpg" alt="" />
              </div>
              <div className="rating">
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
                <span className="fa fa-star" />
              </div>
              <h5 className="name">Monika Vance</h5>
              <span className="designation">Development Expert</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

  )
}

export default Testimonail